import type { SwiperContainer } from "swiper/element/bundle";
import { register } from "swiper/element/bundle";

export function useSwiper() {
  // client only execution
  if (!import.meta.client) {
    return;
  }

  const swiperEl = ref<SwiperContainer | null>(null);

  onMounted(async () => {
    await nextTick();

    register();

    swiperEl.value = document.querySelector("swiper-container");

    if (!swiperEl.value) {
      return;
    }

    swiperEl.value.initialize();
  });

  return { swiperEl: swiperEl };
}
